import React, { useState, useEffect, useRef } from "react";
import { Box, Paper, Typography, IconButton, Button } from "@mui/material";
import { Close, DragIndicator } from "@mui/icons-material";

// Global singleton logger
const logs: string[] = [];
let setGlobalLogs: React.Dispatch<React.SetStateAction<string[]>> | null = null;
let setGlobalIsOpen: React.Dispatch<React.SetStateAction<boolean>> | null = null;

export const chLogger = (msg: string) => {
    const timestamp = new Date().toLocaleTimeString();
    const logEntry = `[${timestamp}] ${msg}`;
    logs.unshift(logEntry);
    if (logs.length > 50) logs.pop();
    if (setGlobalLogs) setGlobalLogs([...logs]);
};
(window as any).chLogger = chLogger;

export const triggerDebugOverlay = () => {
    if (setGlobalIsOpen) setGlobalIsOpen(true);
};

export const DebugOverlay: React.FC = () => {
    const [localLogs, setLocalLogs] = useState<string[]>([]);
    const [isOpen, setIsOpen] = useState(false);

    // Draggable state
    const [position, setPosition] = useState({ x: 0, y: window.innerHeight * 0.6 });
    const isDragging = useRef(false);
    const dragStart = useRef({ x: 0, y: 0 });

    useEffect(() => {
        setGlobalLogs = setLocalLogs;
        setGlobalIsOpen = setIsOpen;
        setLocalLogs([...logs]);
        return () => {
            setGlobalLogs = null;
            setGlobalIsOpen = null;
        };
    }, []);

    const handleTouchStart = (e: React.TouchEvent) => {
        isDragging.current = true;
        const touch = e.touches[0];
        dragStart.current = {
            x: touch.clientX - position.x,
            y: touch.clientY - position.y
        };
    };

    const handleTouchMove = (e: React.TouchEvent) => {
        if (!isDragging.current) return;
        const touch = e.touches[0];
        setPosition({
            x: touch.clientX - dragStart.current.x,
            y: touch.clientY - dragStart.current.y
        });
    };

    const handleTouchEnd = () => {
        isDragging.current = false;
    };

    if (!isOpen) return null;

    return (
        <Paper
            elevation={10}
            sx={{
                position: "fixed",
                top: position.y,
                left: position.x,
                width: "100%",
                height: "40vh",
                zIndex: 30000,
                bgcolor: "rgba(0,0,0,0.9)",
                color: "chartreuse",
                display: "flex",
                flexDirection: "column",
                borderTop: "2px solid red",
                touchAction: "none", // Prevent scrolling while dragging
            }}
        >
            <Box
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
                sx={{
                    p: 1,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #333",
                    cursor: "move",
                    bgcolor: "rgba(255,255,255,0.05)"
                }}
            >
                <Stack direction="row" alignItems="center" spacing={0.5}>
                    <DragIndicator fontSize="small" sx={{ color: "gray" }} />
                    <Typography variant="caption" fontWeight="bold">DEBUG LOGS (v1.1)</Typography>
                </Stack>
                <Box>
                    <Button size="small" onClick={() => { logs.length = 0; setLocalLogs([]); }} sx={{ color: "white", mr: 1, fontSize: "0.6rem" }}>Temizle</Button>
                    <IconButton size="small" onClick={() => setIsOpen(false)} sx={{ color: "white" }}>
                        <Close fontSize="small" />
                    </IconButton>
                </Box>
            </Box>
            <Box sx={{ flex: 1, overflowY: "auto", p: 1, fontFamily: "monospace", fontSize: "0.7rem", touchAction: "auto" }}>
                {localLogs.map((log, i) => (
                    <Box key={i} sx={{ mb: 0.5, borderBottom: "1px solid rgba(255,255,255,0.1)" }}>{log}</Box>
                ))}
            </Box>
        </Paper>
    );
};

import { Stack } from "@mui/material";
